import { Box } from '@factorialco/deprecated-design-system'
import { F0Dialog } from '@factorialco/f0-react'
import { Select } from '@factorialco/f0-react/dist/experimental'
import useLegalEntitiesOptions from 'modules/bookkeepers/hooks/useLegalEntitiesOptions'
import i18n from 'modules/core/lib/i18n'
import { usePrivateIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'
import { useIntegrationsSyncContext } from 'modules/integrations/public'
import { useState, useEffect, useRef } from 'react'

const SyncModal = ({
  companyId,
  payrollRunId,
  countryCode,
  onClose,
}: {
  companyId: string | undefined
  payrollRunId: string
  countryCode: string
  onClose: () => void
}) => {
  const { loading, legalEntitiesOptions } = useLegalEntitiesOptions({ companyId, countryCode })
  const [legalEntityIds, setLegalEntityIds] = useState<string[]>([])
  const hasInitialized = useRef(false)

  const { setContextParameters } = useIntegrationsSyncContext()

  useEffect(() => {
    if (!loading && legalEntitiesOptions.length > 0 && !hasInitialized.current) {
      setLegalEntityIds(legalEntitiesOptions.map((option) => option.value))
      hasInitialized.current = true
    }
  }, [loading, legalEntitiesOptions])
  // FIXME: We shouldn't use privateContext. This modal will be moved to the integrations framework soon.
  const { setFilterParameters, runSynchronisation } = usePrivateIntegrationsSyncContext()

  useEffect(() => {
    if (payrollRunId) {
      setContextParameters({
        payroll_run_id: payrollRunId.toString(),
      })
      setFilterParameters({
        legal_entity_ids: legalEntityIds?.join(','),
      })
    }
  }, [payrollRunId, legalEntityIds, setContextParameters, setFilterParameters])

  return (
    <F0Dialog
      isOpen
      onClose={onClose}
      title={i18n.t('bookkeepers.clients.payroll_cycles.sync_modal.title')}
      primaryAction={{
        label: i18n.t('bookkeepers.clients.payroll_cycles.sync_modal.button.sync'),
        onClick: async () => {
          await runSynchronisation()
          onClose()
        },
        disabled: loading || legalEntityIds.length === 0,
      }}
      secondaryAction={{
        label: i18n.t('common.cancel'),
        onClick: () => onClose(),
      }}
    >
      <Box flexDirection="column" gap="s16">
        <Select
          clearable
          loading={loading}
          label={i18n.t('bookkeepers.clients.payroll_cycles.sync_modal.label')}
          name="legalEntity"
          placeholder={i18n.t('common.select')}
          options={legalEntitiesOptions}
          showSearchBox
          size="md"
          multiple
          value={legalEntityIds}
          onChange={(value: string[]) => setLegalEntityIds(value)}
          required
        />
      </Box>
    </F0Dialog>
  )
}

export default SyncModal
